import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output, SimpleChanges,
  ViewEncapsulation
} from "@angular/core";
import {ConfirmationService, MessageService} from "primeng/api";
import {TranslateService} from "@ngx-translate/core";
import {TableColumnConfig} from "../../../../../../model/api/table-column-config";
import {Trade} from "../../../../../../model/clearing/trade";
import {ClearingInfoLoadRequest} from "../../../../../../model/clearing/clearing-info-load-request";
import {ClearingTradeInfoService} from "../../../../../../services/clearing/clearing-trade-info.service";
import {ClearingSelectionSummary} from "../../../../../../model/clearing/clearing-selection-summary";
import {CommonFieldService} from "../../../../../../services/common/common-field.service";
import {ClearingTradeAggregWsService} from "../../../../../../services/clearing/ws/clearing-trade-aggreg-ws.service";
import {
  ClearingTableConfigTradeAggregService
} from "../../../../../../services/clearing/clearing-table-config-trade-aggreg.service";
import {ClearingTableSyncWsService} from "../../../../../../services/clearing/ws/clearing-table-sync-ws.service";
import {AppConfigService} from "../../../../../../services/app-config.service";
import {ClearingTableConfigService} from "../../../../../../services/clearing/clearing-table-config.service";
import {ClearingCookieService} from "../../../../../../services/clearing/clearing-cookie-service";
import {ClearingSelectionService} from "../../../../../../services/clearing/clearing-selection.service";
import {TradeAggregateTableComponent} from "../../../trade-aggregate/trade-aggregate-table.component";
import {ClearingAllocationService} from "../../../../../../services/clearing/clearing-allocation.service";
import {ClearingAllocationTaskService} from "../../../../../../services/clearing/clearing-allocation-task.service";
import {InternalTradeOrderViewService} from "../../../../../../services/internal/internal-trade-order-view.service";
import {ThemeService} from "../../../../../../services/tools/theme.service";
import Side = Trade.Side;
import {finalize, Subscription} from "rxjs";
import {CtrlAMode} from "../../trade-table.component";
import {SelectionType} from "../../../../../../crystal-elements/cc-vscroll-table/cc-vscroll-table.component";
import {AllocationTask} from "../../../../../../model/clearing/allocation/allocation-task";
import {TableRequest} from "../../../../../../model/api/table-request";

@Component({

  selector: 'app-trade-selection-table',
  templateUrl: './trade-selection-table.component.html',
  styleUrls: ['./trade-selection-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [

    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TradeSelectionTableComponent extends TradeAggregateTableComponent {

  ctrlAModeHeadMssg: string = '';

  tableColumns: string[] = [];

  tableHeaderLoadingCount: number = 0;

  selectedTradeIds: string[] = [];
  @Output()
  selectedIdsChange = new EventEmitter<string[]>();
  @Output()
  applySelectionChange = new EventEmitter<string[]>();

  @Output()
  doSingleAllocate = new EventEmitter<string[]>();
  @Output()
  doSplitAllocate = new EventEmitter<string[]>();

  @Input()
  tradeIds: string[];

  @Input()
  ctrlAMode: CtrlAMode = 'ALL_OPTIM';
  @Input()
  selectionType: SelectionType = 'CUSTOM';

  @Input()
  filterWithValue: any[] = [];

  @Input()
  selectionTradeDialogVisible: boolean = false;

  @Input()
  tradeTableCurrentRequest: TableRequest;

  @Output()
  columnOrderChange = new EventEmitter<TableColumnConfig[]>();

  private minItemCountForSelectionDetail: number = 1;

  private selectionSummarySubscription?: Subscription;

  private summaryReloadTimeout?: ReturnType<typeof setTimeout>;
  private summaryRequestInFlightKey?: string;
  private summaryRequestLoadedKey?: string;

  constructor(cdref: ChangeDetectorRef,
              allocationService: ClearingAllocationService,
              allocationTaskService: ClearingAllocationTaskService,
              protected commonFieldService: CommonFieldService,
              protected userViewService: InternalTradeOrderViewService,
              appConfigService: AppConfigService,
              clearingWsService: ClearingTradeAggregWsService,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              public translateService: TranslateService,
              public themeService: ThemeService,
              protected clearingTradeInfoService: ClearingTradeInfoService,
              public tableConfigService: ClearingTableConfigService,
              protected clearingCookieService: ClearingCookieService,
              protected clearingTableSyncWsService: ClearingTableSyncWsService,
              protected clearingSelectionService: ClearingSelectionService,
              protected clearingTableConfigTradeAggregService: ClearingTableConfigTradeAggregService) {
    super(cdref,
      allocationService,
      allocationTaskService,
      commonFieldService,
      userViewService,
      appConfigService,
      clearingWsService,
      messageService,
      confirmationService,
      translateService,
      themeService,
      clearingTradeInfoService,
      tableConfigService,
      clearingCookieService,
      clearingTableSyncWsService,
      clearingSelectionService,
      clearingTableConfigTradeAggregService);
    this.clear();
    this.selectionBase = true;
  }

  private userExplicitSelection = false;

// Add ngOnChanges (component needs to implement OnChanges)
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectionType'] || changes['tradeIds'] || changes['selectionTradeDialogVisible']) {
      this.userExplicitSelection = false;
    }
    super.ngOnChanges(changes);
  }

  ngOnDestroy(): void {
    this.selectionSummarySubscription?.unsubscribe();

    if (this.summaryReloadTimeout) {
      clearTimeout(this.summaryReloadTimeout);
      this.summaryReloadTimeout = undefined;
    }

    super.ngOnDestroy();
  }

  public refreshColumns() {
    this.tableConfig = this.clearingTableConfigTradeAggregService.buildTableConfig(this.viewConfig, this.visibleColumns,
      this.exchanges, this.filterWithValue);
    this.tableColumns.splice(0);
    this.tableColumns.push(...this.tableConfig.map(value => value.field));
    this.markForCheck();
  }

  refreshSelectionInfos() {
    this.refreshSelectedIds();
  }

  private refreshSelectedIds(emitEvent: boolean = true): void {
    let tempTradeSelectedIds: string[];

  /*  if (this.isCtrlAModeApplied() && !this.userExplicitSelection) {
      // Ctrl+A with no user override: all records
      console.log("----> isCtrlAModeApplied=" + this.isCtrlAModeApplied()
        + " userExplicitSelection=" + this.userExplicitSelection
        + " tradeIds=" + this.tradeIds.length)
      tempTradeSelectedIds = this.tradeIds ? [...this.tradeIds] : [];
    } else */if (this.selectedIds && this.selectedIds.length > 0) {
      // Explicit selection inside the table takes priority
      // console.log("----> selectedIds=" + this.selectedIds.length)
      tempTradeSelectedIds = this.getTrueSelectedTradeIds(this.selectedIds);
    } else if (this.selectionBase) {
      // console.log("----> selectionBase=" + this.selectionBase + " tradeIds=" + this.tradeIds.length)
      tempTradeSelectedIds = this.tradeIds ? [...this.tradeIds] : [];
    } else {
      // console.log("----> recordIds=" + this.recordIds.length)
      tempTradeSelectedIds = this.getTrueSelectedTradeIds(this.recordIds);
    }

    const hasChanged = !this.sameIds(this.selectedTradeIds, tempTradeSelectedIds);
    this.selectedTradeIds = tempTradeSelectedIds;

    this.scheduleLoadHeaderInfos(tempTradeSelectedIds);

    if (hasChanged && emitEvent) {
      this.selectedIdsChange.emit([...this.selectedTradeIds]);
    }
  }

  private clear() {
    this.summaryBuyValue = new ClearingSelectionSummary(Side.BUY);
    this.summarySellValue = new ClearingSelectionSummary(Side.SELL);
  }

  private loadHeaderInfos(tradeIds: string[]) {
    const request = this.buildSummaryRequest(tradeIds);
    const requestKey = this.buildSummaryRequestKey(request);
    const itemCount = request.itemIds?.length ?? 0;

    if (
      requestKey === this.summaryRequestInFlightKey ||
      requestKey === this.summaryRequestLoadedKey
    ) {
      return;
    }

    if (
      !this.summaryRequest ||
      JSON.stringify(this.summaryRequest.itemIds ?? []) !== JSON.stringify(request.itemIds ?? [])
    ) {
      this.clear();
    }

    this.summaryRequest = request;

    this.selectionSummarySubscription?.unsubscribe();
    this.selectionSummarySubscription = undefined;
    this.summaryRequestInFlightKey = undefined;

    if (itemCount >= this.appConfigService.selectionSummaryHardLimitCount) {
      this.clear();
      this.summaryBuyValue.selectionCount = this.selectedTradeIds.length;
      this.markForCheck();
      this.summaryRequestLoadedKey = requestKey;
      return;
    }

    setTimeout(() => {
      this.tableHeaderLoadingCount++;
    });

    const requestVersion = ++this.selectionSummaryRequestVersion;
    this.summaryRequestInFlightKey = requestKey;

    this.selectionSummarySubscription = this.clearingTradeInfoService
      .getSelectionSummary(request)
      .pipe(
        finalize(() => {
          if (this.summaryRequestInFlightKey === requestKey) {
            this.summaryRequestInFlightKey = undefined;
          }

          setTimeout(() => {
            if (this.tableHeaderLoadingCount > 0) {
              this.tableHeaderLoadingCount--;
            }
          });
        })
      )
      .subscribe(apiValidation => {
        if (requestVersion !== this.selectionSummaryRequestVersion) {
          return;
        }

        if (apiValidation.success) {
          const sumBuyValue = apiValidation.item.find(value => value.side === Side.BUY);
          if (sumBuyValue) {
            this.summaryBuyValue = sumBuyValue;
          }

          const sumSellValue = apiValidation.item.find(value => value.side === Side.SELL);
          if (sumSellValue) {
            this.summarySellValue = sumSellValue;
          }

          this.summaryRequestLoadedKey = requestKey;
          this.markForCheck();
        }
      });
  }

  public applySelection() {
    this.applySelectionChange.emit(this.selectedTradeIds);
  }

  public clearSelection() {
    this.applySelectionChange.emit([]);
  }

  public singleAllocate() {
    this.doSingleAllocate.emit(this.selectedTradeIds);
  }

  public splitAllocate() {
    this.doSplitAllocate.emit(this.selectedTradeIds);
  }

  selectionChanged($event: any) {
    this.userExplicitSelection = true;
    this.refreshSelectedIds();
  }

  prepareRequestBeforePost(requestToPrepare: ClearingInfoLoadRequest) {
    const request: ClearingInfoLoadRequest = {
      ...super.prepareRequestBeforePost(requestToPrepare),
      ignoreFields: this.filterWithValue ? [...this.filterWithValue] : [],
      itemIds: [],
      selectionBase: this.selectionBase
    };

    request.filters3 = [...(request.filters3 ?? [])];

    if (this.tradeTableCurrentRequest?.filters?.length) {
      request.filters3.push(...this.tradeTableCurrentRequest.filters);
    }

    const shouldSendExplicitIds =
      !this.isCtrlAModeApplied()
      && (this.tradeIds?.length ?? 0) >= this.minItemCountForSelectionDetail;

    if (shouldSendExplicitIds) {
      request.itemIds = [...this.tradeIds];
    }

    return request;
  }

  public onSyncApplied() {
    if (this.isCtrlAModeApplied() && !this.userExplicitSelection) {
      setTimeout(() => this.refreshSelectedIds(false));
    }
  }

  protected loadSettingsFromCookies() {
    // console.log("----> loadSettingsFromCookies ", JSON.stringify(this.tradeTableCurrentRequest.filters))
    // const adaptedTradeTableRequest: TableRequest = new TableRequest({});
    // adaptedTradeTableRequest.filters3.push(...this.tradeTableCurrentRequest.filters);
    // this.ccTable.setFiltersAndSort(adaptedTradeTableRequest)
    // console.log("----> loadSettingsFromCookies2 ", JSON.stringify(adaptedTradeTableRequest.filters3))
    // this.tableCurrentRequest = adaptedTradeTableRequest;
  }

  public isCtrlAModeApplied(): boolean {
    this.ctrlAModeHeadMssg = '';

    const tradeCount = this.tradeIds?.length ?? 0;
    const secureLimit = this.appConfigService.tradeAggregationSecureCountLimit;
    const allOptimLimit = this.appConfigService.tradeAggregationAllModeCountLimit;
    const baseMessage = this.getTranslation('page.clearing.trade.selection.dialog_ctrlAModeAll');

    if (this.selectionType === 'CTRLA') {
      if (this.ctrlAMode === 'ALL') {
        this.ctrlAModeHeadMssg = baseMessage;
        return true;
      }

      const threshold = this.ctrlAMode === 'ALL_OPTIM' ? allOptimLimit : secureLimit;

      if (tradeCount > threshold) {
        this.ctrlAModeHeadMssg =
          baseMessage +
          this.getTranslation(
            'page.clearing.trade.selection.ctrl_a_all_applied_threshold_mssg',
            {threshold}
          );
        return true;
      }

      return false;
    }

    if (tradeCount > secureLimit) {
      this.ctrlAModeHeadMssg =
        baseMessage +
        this.getTranslation(
          'page.clearing.trade.selection.ctrl_a_all_applied_threshold_mssg',
          {threshold: secureLimit}
        );
      return true;
    }

    return false;
  }

  private sameIds(left?: string[], right?: string[]): boolean {
    if (left === right) {
      return true;
    }

    if (!left || !right || left.length !== right.length) {
      return false;
    }

    for (let i = 0; i < left.length; i++) {
      if (left[i] !== right[i]) {
        return false;
      }
    }

    return true;
  }

  private buildSummaryRequest(tradeIds: string[]): ClearingInfoLoadRequest {
    const infoTradeIds =
      tradeIds.length >= this.minItemCountForSelectionDetail ? [...tradeIds] : [];

    return {
      ignoreFields: this.filterWithValue ? [...this.filterWithValue] : [],
      itemIds: infoTradeIds,
      selectionBase: this.selectionBase,
      tabId: this.tableCurrentRequest?.tabId,
      filters: this.tableCurrentRequest?.filters,
      filters2: this.tableCurrentRequest?.filters2,
      filters3: this.tableCurrentRequest?.filters3,
      globalFilter: this.tableCurrentRequest?.globalFilter,
      stateFilter: this.tableCurrentRequest ? this.tableCurrentRequest['stateFilter'] : undefined
    } as ClearingInfoLoadRequest;
  }

  private buildSummaryRequestKey(request: ClearingInfoLoadRequest): string {
    return JSON.stringify({
      ignoreFields: request.ignoreFields ?? [],
      itemIds: request.itemIds ?? [],
      selectionBase: request.selectionBase,
      tabId: request.tabId,
      filters: request.filters ?? [],
      filters2: request.filters2 ?? [],
      filters3: request.filters3 ?? [],
      globalFilter: request.globalFilter ?? null,
      stateFilter: request['stateFilter'] ?? null
    });
  }

  private scheduleLoadHeaderInfos(tradeIds: string[]): void {
    if (this.summaryReloadTimeout) {
      clearTimeout(this.summaryReloadTimeout);
    }

    const idsSnapshot = [...tradeIds];

    this.summaryReloadTimeout = setTimeout(() => {
      this.summaryReloadTimeout = undefined;
      this.loadHeaderInfos(idsSnapshot);
    }, 120);
  }

  public override isWsRefreshEnabled(): boolean {
    return this.selectionTradeDialogVisible;
  }
}
